// ============================================
// ExpedienteTypeahead — buscador/selector INLINE de expediente (REUTILIZABLE)
// ============================================
// Extraido del cotizador (ModalEscanearCotizacion): typeahead con busqueda
// server-side (GET /api/oportunidades?search=), devuelve el OBJETO elegido
// {id, folio, titulo, cliente_nombre, ...} o null. Un solo componente para el
// cotizador y el calendario (no reinventar el selector).

import React, { useState, useEffect, useRef } from 'react';
import { X, Search } from 'lucide-react';
import { API_BASE_EXP, PP_EXP } from './helpersExpedientes';
import { authHeaders } from '../utils/storage';

const BORDE = '#e6e8ea';
const OSCURO = '#2f5f9e';
const GRIS = '#4e5357';

export default function ExpedienteTypeahead({ valor, onElegir, placeholder, autoFocus }) {
  const [q, setQ] = useState('');
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const debRef = useRef(null);

  useEffect(() => {
    if (debRef.current) clearTimeout(debRef.current);
    const term = q.trim();
    if (term.length < 2) { setResultados([]); return undefined; }
    debRef.current = setTimeout(async () => {
      try {
        const r = await fetch(`${API_BASE_EXP}/api/oportunidades?search=${encodeURIComponent(term)}`, { headers: authHeaders() }).then(x => x.json());
        const arr = Array.isArray(r) ? r : (r.oportunidades || []);
        setResultados(arr.slice(0, 8));
      } catch (e) { setResultados([]); }
    }, 350);
    return () => { if (debRef.current) clearTimeout(debRef.current); };
  }, [q]);

  if (valor) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#eaf2fb', border: `1px solid ${BORDE}`, borderRadius: 10, padding: '10px 12px' }}>
        <span style={{ flex: 1, fontSize: 14, color: OSCURO, fontFamily: PP_EXP }}>
          <b>{valor.folio || `#${valor.id}`}</b>{valor.titulo ? ` · ${valor.titulo}` : ''}{valor.cliente_nombre ? ` — ${valor.cliente_nombre}` : ''}
        </span>
        <button type="button" onClick={() => { onElegir(null); setQ(''); setAbierto(false); }}
          aria-label="Quitar expediente"
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: GRIS, padding: 8, minWidth: 44, minHeight: 44, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}>
          <X size={18} />
        </button>
      </div>
    );
  }
  return (
    <div style={{ position: 'relative' }}>
      <Search size={16} style={{ position: 'absolute', left: 10, top: 14, color: GRIS, opacity: 0.6 }} />
      <input
        value={q} autoFocus={autoFocus}
        onChange={(e) => { setQ(e.target.value); setAbierto(true); }}
        placeholder={placeholder || 'Buscar expediente por folio, título o cliente…'}
        style={{ width: '100%', padding: '10px 12px 10px 32px', border: `1px solid ${BORDE}`, borderRadius: 10, fontSize: 16, minHeight: 44, fontFamily: PP_EXP, boxSizing: 'border-box', color: GRIS, background: '#fff' }}
      />
      {abierto && resultados.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: `1px solid ${BORDE}`, borderRadius: 10, marginTop: 4, boxShadow: '0 8px 20px rgba(0,0,0,0.12)', zIndex: 20, maxHeight: 240, overflowY: 'auto' }}>
          {resultados.map(o => (
            <button key={o.id} type="button" onClick={() => { onElegir(o); setAbierto(false); setQ(''); }}
              style={{ display: 'block', width: '100%', textAlign: 'left', border: 'none', borderBottom: `1px solid ${BORDE}`, background: '#fff', padding: '12px', minHeight: 44, cursor: 'pointer', fontFamily: PP_EXP, fontSize: 13, color: GRIS }}>
              <b style={{ color: OSCURO }}>{o.folio || `#${o.id}`}</b>
              {o.titulo ? ` · ${String(o.titulo).slice(0, 50)}` : ''}
              {o.cliente_nombre ? ` — ${o.cliente_nombre}` : ''}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
